import "./styles.css";

function Paralax() {
    return (
        <article>
            <div className="bg-fundo">
                <p className="title" >Filmes ScoreXP</p>
                <p className="sub-title">Aqui você ver os melhores filmes </p>
            </div>
        </article>
    )
}

export default Paralax;